import { SectionDataById } from '@components/dynamic-form/types';
import { nprQuestions, exemptionQuestions } from './nprData.questions';

export const sectionsById: SectionDataById = {
  1: {
    formId: 1,
    sectionName: 'No Permit Required',
    questions: nprQuestions,
  },
  2: {
    formId: 1,
    sectionName: '404(f) Exemptions (33 CFR 323.4)',
    additionalInfo:
      'A permit is required unless your project qualifies for a Section 404(f) exemption. [Learn more about exempt activities](https://www.ecfr.gov/current/title-33/chapter-II/part-323/section-323.4)',
    questions: exemptionQuestions,
  },
};
